import { createStore } from '../lib/store';
import { postAction } from '../api/client';
import { clearCache } from '../lib/swr';
import type { LoginResponse } from '../api/types';
import { isErr } from '../api/types';

export interface Session {
  token: string;
  operatorId: string;
  operatorName: string;
  role: 'operator' | 'admin';
}

const store = createStore<Session | null>(null, 'logbook.session');

export const useSession = () => store.use();

/** The stored session, if any. Sessions are persistent — they never expire on
 *  their own; they end only when the user signs out. */
export function currentSession(): Session | null {
  return store.get();
}

export function signOut(): void {
  store.set(null);
  clearCache();
}

export async function signIn(operatorId: string, pin: string): Promise<{ ok: true } | { ok: false; message: string }> {
  const res = await postAction<LoginResponse>('login', { operatorId: operatorId.trim(), pin });
  if (isErr(res)) return { ok: false, message: res.message };
  store.set({
    token: res.token,
    operatorId: res.operator.id,
    operatorName: res.operator.name,
    role: res.operator.role,
  });
  // warm the read caches in the background so the first screen paints instantly
  void import('../lib/prefetch').then((m) => m.warmCaches(res.operator.role)).catch(() => {});
  return { ok: true };
}
